<template>
  <v-container fluid class="bankaccount-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/bankaccount/add" color="success" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn to="/gl-post/list" color="default" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                GL Post
              </v-btn>
              <v-btn to="/gl-report/list" color="default" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Reports
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              v-model="item_seleted"
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="bankaccounts-table"
              show-select
              single-select
              item-key="_id"
              :footer-props="footer"
              :headers="header_bankaccounts"
              :items="[
                ...bankaccounts.filter(i=>i.accountstatus=='Active'),
                ...bankaccounts.filter(i=>i.accountstatus!='Active'),
              ]"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteBankAccount"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Bank Account?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_bankaccount.accountcode }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteBankAccount = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteBankAccount(delete_bankaccount)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.accountstatus="{ item }">
                <v-chip
                  v-if="item.accountstatus!=undefined"
                  :color="getStatusColor(item.accountstatus)"
                  small
                >
                  {{ item.accountstatus }}
                </v-chip>
              </template>
              <template v-slot:item.accountcode="{ item }">
                <p class="two-line">{{ item.accountcode }}</p>
                <p class="two-line">{{ item.accountname }}</p>
              </template>
              <template v-slot:item.statements="{ item }">
                <span style="font-size: 10pt;">{{ item.statements.length }}</span>
              </template>
              <template v-slot:item.accountstartdate="{ item }">
                <p v-if="item.accountstartdate!=null" class="two-line">{{ new Date(item.accountstartdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}<span>&nbsp;-&nbsp;</span></p>
                <p v-if="item.accountenddate!=null" class="two-line">{{ new Date(item.accountenddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</p>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="editBankAccount(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn v-if="item.accountstatus=='New'" icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { getStatusColor } from '@/util/tools';

export default {
  name: 'BankAccountList',
  data() {
    return {
      isDeleteBankAccount: false,
      isLoading: false,
      delete_bankaccount: {},
      item_seleted: [],
      header_bankaccounts: [
        { text: 'Account Name', value: 'accountcode'},
        { text: 'Type', value: 'accounttype'},
        { text: 'Open & Closing', value: 'accountstartdate' },
        { text: 'Stm', value: 'statements', width: "10%", align:"center"  },
        { text: 'Status', value: 'accountstatus', width: "10%"  },
        { text: 'Actions', value: 'actions', sortable: false, width: "10%" },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      getStatusColor: getStatusColor,
    }
  },
  computed: {
    ...mapState('BankAccount', ['bankaccounts', 'isReceiving', 'isDeleting', 'idToDelete', 'isUpdating']),
  },
  async created () {
    await this.getBankAccountsRequest();
  },
  methods: {
    ...mapActions('BankAccount', ["deleteBankAccountRequest","getBankAccountsRequest"]),
    viewItem(item) {
      this.$router.push({ name: 'BankAccountView', params: item });
    },
    editBankAccount(item) {
      this.$router.push({name: 'BankAccountEdit', params: item});
    },
    deleteBankAccount(item) {
      this.deleteBankAccountRequest({_id: item._id});
      this.isDeleteBankAccount = false;
    },
    deleteDialog(item) {
      this.isDeleteBankAccount = true;
      this.delete_bankaccount = {_id: item._id, accountcode: item.accountcode};
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
